import { faTimes, faInfoCircle } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Dialog } from "@headlessui/react"
import { IKImage } from "imagekitio-react"
import { useRef } from "react"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { toast } from 'react-toastify'
import { addQuizSuggestion } from "../../../redux/actions/userActivity"
import { useParams } from "react-router-dom"
import './index.css'

export default function ReportQuizModal({ openReportModal, setOpenReportModal, quizDetails, currentQuizIndex }) {

    const quizSuggestionRef = useRef()
    const questionRef = useRef()
    const answerRef = useRef()
    const wrong1Ref = useRef()
    const wrong2Ref = useRef()
    const wrong3Ref = useRef()
    const dispatch = useDispatch()
    const user_id = useSelector(store => store?.profileDetails?.id)
    const {contentId} = useParams();

    function handleQuizReport() {
        if (quizSuggestionRef?.current?.value?.length > 0) {
            dispatch(addQuizSuggestion(user_id,contentId ,  quizDetails?.[0]?.id,
                quizSuggestionRef?.current?.value,
                questionRef?.current?.value,
                answerRef?.current?.value,
                wrong1Ref?.current?.value,
                wrong2Ref?.current?.value,
                wrong3Ref?.current?.value,
                successObj => {
                    setOpenReportModal(false)
                    console.log(successObj)
                }))


        }
        else {
            toast.warn("Quiz Report Reason is Required!")
        }
    }

    return (
        <Dialog open={openReportModal} onClose={() => setOpenReportModal(false)
        }
            as="div"
            className="fixed inset-0 z-10 overflow-y-auto md:-top-16 top-5 flex md:justify-start md:mt-28 w-full h-[90%] justify-center flex-col items-center" >
            <Dialog.Overlay className="fixed inset-0 bg-black opacity-70 z-10" />
            <Dialog.Title />
            <Dialog.Description />
            <div className="bg-white relative z-20 flex justify-between flex-col items-start w-11/12 md:p-8 p-2 rounded md:w-3/5 lg:w-2/5">
                <FontAwesomeIcon icon={faTimes} className="absolute top-3 right-3 md:text-2xl cursor-pointer" onClick={() => { setOpenReportModal(false) }} />
                <div className="flex justify-center items-center">
                    <img
                        urlEndpoint="https://assets.learntube.ai/files/"
                        src={"https://assets.learntube.ai/files/Content_player/feedbackModal.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1662628545349"}
                        transformation={[{
                            "height": "110",
                            "width": "110",
                        }]}
                        className="md:h-12 h-16"
                    />
                    <h2 className='md:text-xl text-base font-bold mb-3 text-center ml-4'>Report This Quiz Question</h2>
                </div>
                <p className='text-base md:text-lg font-semibold'>What is wrong with this quiz Question?<span className='text-red-500'>*</span></p>
                <textarea ref={quizSuggestionRef} name="" id="" cols="50" rows="2" placeholder='Describe what is wrong with this quiz question' className='w-full border-2 my-2 border-gray-300 rounded-lg resize-none' required></textarea>
                <p className='text-base md:text-lg font-semibold md:mt-3 mt-1'>Suggest Replacement for this quiz question</p>
                <input ref={questionRef} type="text" name="" id="" className='w-full border-2 my-2 border-gray-300 rounded' placeholder='Write your question here' />
                <div className="flex justify-between items-center w-full">
                    <p className="mr-4 font-bold">A</p>
                    <input ref={answerRef} type="text" name="" id="" className='w-full border-2 my-2 border-[#2BBD13] rounded' placeholder='Correct Answer' />
                </div>
                <div className="flex justify-between items-center w-full">
                    <p className="mr-4 font-bold">B</p>
                    <input ref={wrong1Ref} type="text" name="" id="" className='w-full border-2 my-2 border-[#FF2633] rounded' placeholder='Wrong Answer 1' />
                </div>
                <div className="flex justify-between items-center w-full">
                    <p className="mr-4 font-bold">C</p>
                    <input ref={wrong2Ref} type="text" name="" id="" className='w-full border-2 my-2 border-[#FF2633] rounded' placeholder='Wrong Answer 2' />
                </div>
                <div className="flex justify-between items-center w-full">
                    <p className="mr-4 font-bold">D</p>
                    <input ref={wrong3Ref} type="text" name="" id="" className='w-full border-2 my-2 border-[#FF2633] rounded' placeholder='Wrong Answer 3' />
                </div>
                <div className='flex justify-center items-center'>
                    <FontAwesomeIcon icon={faInfoCircle} className="text-[#086788]" />
                    <small className='font-bold text-supertiny ml-2'>You will earn 10 coins for each suggestion that is accepted.</small>
                </div>
                {/* <small className='font-bold text-supertiny md:ml-12'>You will earn 10 coins for each suggestion that is accepted.</small> */}
                <button  className='report-button md:mt-10 mt-4 px-3 font-semibold py-2 rounded self-end' onClick={() => handleQuizReport()}>Report Suggestion</button>
            </div>
        </Dialog >
    )
}